"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExpandedCheckbox_1 = __importDefault(require("@/components/molecules/ExpandedCheckbox"));
const Shared_1 = require("@/components/styled-controls/Shared");
const constant_1 = require("@/constants/constant");
const react_1 = __importStar(require("react"));
const Layout_1 = __importDefault(require("../Layout"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const useApiService_1 = require("@/api/useApiService");
const componentlibrary_1 = require("@emarketer/componentlibrary");
const code_helpers_1 = require("@emarketer/code-helpers");
const PushFormSuccessValuestoDataLayer_1 = require("@/helpers/PushFormSuccessValuestoDataLayer");
const NewsLetter = () => {
    const { setStep, userData, setUserData, appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { analyticsPrefix, salesforceProxyApiUrl } = appProps;
    const registrationStepCopy = appProps.registrationStepCopy?.NEWSLETTERS?.TITLE || constant_1.HEADER_TEXTS.NEWSLETTERS.TITLE;
    const subHeaderText = appProps.registrationStepCopy?.NEWSLETTERS?.SUBTITLE || constant_1.HEADER_TEXTS.NEWSLETTERS.SUBTITLE;
    const availableNewsletters = userData.availableNewsletters;
    // Pre-select EMARKETER Daily for freemium onboarding only for first-time visitors
    const getInitialNewsletters = () => {
        // If user has newsletters data (even if empty array), respect their choice
        // this is useful when user unselects emarketer daily and goes back to the industry step
        if (userData?.newsletters !== undefined) {
            return userData.newsletters;
        }
        // Pre-select EMARKETER Daily only for new users during freemium onboarding
        const hasEmarketerDaily = availableNewsletters?.some((n) => n.title === constant_1.EMARKETER_DAILY_TEXT);
        return hasEmarketerDaily ? [constant_1.EMARKETER_DAILY_TEXT] : [];
    };
    const [selectedNewsletters, setSelectedNewsletters] = (0, react_1.useState)(getInitialNewsletters());
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false);
    // Capture whether the user is new (no prior newsletter selection) at mount time.
    // Used to defer EMARKETER Daily pre-selection until availableNewsletters loads.
    const wasNewUser = (0, react_1.useRef)(userData?.newsletters === undefined);
    (0, react_1.useEffect)(() => {
        if (wasNewUser.current && availableNewsletters) {
            const hasEmarketerDaily = availableNewsletters.some((n) => n.title === constant_1.EMARKETER_DAILY_TEXT);
            setSelectedNewsletters(hasEmarketerDaily ? [constant_1.EMARKETER_DAILY_TEXT] : []);
        }
    }, [availableNewsletters]);
    // Sync userData.newsletters with selectedNewsletters for ExpandedCheckbox component
    (0, react_1.useEffect)(() => {
        setUserData((prevData) => ({ ...prevData, newsletters: selectedNewsletters }));
    }, [selectedNewsletters, setUserData]);
    const handleNewsletterChange = (newsletter, checked) => {
        setSelectedNewsletters((prevNewsletters) => checked ? [...prevNewsletters, newsletter] : prevNewsletters.filter((item) => item !== newsletter));
    };
    const { userService } = (0, useApiService_1.useApiService)();
    /**
     * Handles submitting the form values to the data layer.
     */
    const submitToDataLayer = () => {
        (0, PushFormSuccessValuestoDataLayer_1.pushFormSuccessValuestoDataLayer)({
            'form-name': `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-newsletters`,
            email: userData.email,
            id: userData.id,
            newsletters: selectedNewsletters,
        });
    };
    /**
     * Updates user data and advances to the success step.
     */
    const successHandler = () => {
        setUserData((prevData) => ({ ...prevData, newsletters: selectedNewsletters }));
        submitToDataLayer();
        setStep('success');
    };
    /**
     * Submits newsletter preferences to SalesforceProxy and advances to the success step.
     * SF failures are non-blocking — errors are logged and the user always proceeds.
     */
    const handleNext = async () => {
        setIsButtonDisabled(true);
        try {
            const selections = availableNewsletters.map((newsletter) => ({
                mailingListId: newsletter.id,
                subscribed: selectedNewsletters.includes(newsletter.title),
            }));
            const response = await userService.submitNewsletterPreferences(salesforceProxyApiUrl, userData.email, selections);
            if (!response.isSuccess) {
                console.error('Newsletter preferences submission failed:', response.errorCode, response.errors);
            }
        }
        catch (error) {
            console.error('Failed to submit newsletter preferences:', error);
        }
        successHandler();
        setIsButtonDisabled(false);
    };
    if (!availableNewsletters) {
        return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: registrationStepCopy, subHeaderText: subHeaderText },
            react_1.default.createElement(Shared_1.NewsletterContainer, null,
                react_1.default.createElement("p", null, "Loading newsletters..."))));
    }
    const midpoint = Math.ceil(availableNewsletters.length / 2);
    const newsletterColumns = [availableNewsletters.slice(0, midpoint), availableNewsletters.slice(midpoint)];
    const renderCheckboxColumn = (newsletters) => (react_1.default.createElement(Shared_1.CheckboxColumn, null, newsletters.map(({ id, title, description }) => (react_1.default.createElement(ExpandedCheckbox_1.default, { key: id, label: title, value: title, description: description, onClick: handleNewsletterChange, analytics: constant_1.DATA_ANALYTICS_TAG.NEWSLETTERS.NEWSLETTER_SELECTION(analyticsPrefix, (0, code_helpers_1.removeSpacesAndNonAlphaNumeric)(title)), id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.CHECKBOX}-${id}`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.CHECKBOX}-${id}` })))));
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: registrationStepCopy, subHeaderText: subHeaderText },
        react_1.default.createElement(Shared_1.NewsletterContainer, null,
            react_1.default.createElement(Shared_1.CheckboxContainer, null, newsletterColumns.map(renderCheckboxColumn)),
            react_1.default.createElement(Shared_1.NewsletterTerms, null, "By clicking \"Finish,\" you're agreeing to receive our newsletters. Plus, you'll also receive FYI emails packed with additional insights and updates to keep you in the loop!"),
            react_1.default.createElement(Shared_1.ButtonContainer, null,
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "custom", callback: () => {
                        setUserData((prevUserData) => ({ ...prevUserData, newsletters: selectedNewsletters })); // make sure selected item is saved in context while going back
                        setStep('industry');
                    }, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.NEWSLETTERS.BACK(analyticsPrefix), size: "m", style: {
                        backgroundColor: `${componentlibrary_1.COLOR.II.WHITE}`,
                        color: `${componentlibrary_1.COLOR.II.BLACK}`,
                        border: `1px solid ${componentlibrary_1.COLOR.II.BLACK}`,
                    }, "$isCustom": true, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-back-newsletters`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-back-newsletters` }, "Back"),
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "default", callback: () => {
                        handleNext();
                    }, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.NEWSLETTERS.NEXT(analyticsPrefix), size: "m", disabled: selectedNewsletters.length === 0 || isButtonDisabled, "$isDisabled": selectedNewsletters.length === 0 || isButtonDisabled, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-finish-newsletters` }, "Finish")),
            react_1.default.createElement(Shared_1.SkipButtonContainer, null,
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "a", buttonType: "custom", dataAnalytics: constant_1.DATA_ANALYTICS_TAG.NEWSLETTERS.SKIP(analyticsPrefix), size: "m", id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-${(0, code_helpers_1.removeSpacesAndNonAlphaNumeric)(constant_1.NEWSLETTER_FINISH_WO_INSIGHTS).toLowerCase()}`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-${(0, code_helpers_1.removeSpacesAndNonAlphaNumeric)(constant_1.NEWSLETTER_FINISH_WO_INSIGHTS).toLocaleLowerCase()}`, style: {
                        color: `${componentlibrary_1.COLOR.II.BLUE.DEFAULT}`,
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '300',
                        visibility: selectedNewsletters.length === 0 ? 'visible' : 'hidden',
                        background: 'transparent',
                        textAlign: 'center',
                        display: 'inline-block',
                        cursor: 'default',
                        padding: '5px',
                    }, "$isCustom": true, onClick: (event) => {
                        event.preventDefault();
                        submitToDataLayer();
                        setStep('success');
                    } },
                    react_1.default.createElement("span", { style: { display: 'inline-block', cursor: 'pointer' } }, constant_1.NEWSLETTER_FINISH_WO_INSIGHTS))))));
};
exports.default = NewsLetter;
